import { useMutation } from "@tanstack/react-query";

import { API_ROUTES } from "../api/ApiRoutes";
import { getPrivateInstance } from "./_privateInstance";

export type ResetStaffMfaEnvelope = {
  success: true;
  message?: string;
  msg_code: "pam.success.staff_mfa_reset";
  data?: unknown;
};

export const resetStaffMfa = async (
  adminId: string,
): Promise<ResetStaffMfaEnvelope> => {
  const url = API_ROUTES.STAFF_RESET_MFA.replace("{admin_id}", adminId);
  const response = await getPrivateInstance().patch<ResetStaffMfaEnvelope>(url);
  return response.data;
};

export const useResetStaffMfa = () =>
  useMutation({
    mutationKey: ["RESET_STAFF_MFA"],
    mutationFn: resetStaffMfa,
  });
